import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4f53363f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contents" }
const _hoisted_2 = {
  key: 0,
  class: "header"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Working...", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "header error"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please contact support.", -1))
const _hoisted_7 = {
  key: 2,
  class: "header"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Done! Press the button below to refresh the page.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Pardon the interruption,"),
  /*#__PURE__*/_createElementVNode("p", null, "it would seem like your builder had gotten deleted at some point, resulting in some breakages. We simply need you to select which builder should be associated with your (the currently logged in) account.")
], -1))
const _hoisted_11 = { class: "selection-area" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  hidden: ""
}, "Select a builder", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Account error"),
  /*#__PURE__*/_createElementVNode("p", null, "Please contact support with a screenshot of this page")
], -1))
const _hoisted_17 = { class: "info" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Debug info:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["SimpleModal"], {
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
    "click-to-close": !$setup.loading
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        ($setup.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : ($setup.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("h2", null, "Error: " + _toDisplayString($setup.error), 1),
                _hoisted_6
              ]))
            : ($setup.done)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _hoisted_9,
                  _createElementVNode("button", { onClick: $setup.doReload }, "Refresh")
                ]))
              : ($setup.builders.asArray.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedBuilder) = $event))
                      }, [
                        _hoisted_12,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.builders.asArray, (builder) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: builder.$id
                          }, _toDisplayString(builder.name.fullName), 9, _hoisted_13))
                        }), 256))
                      ], 512), [
                        [_vModelSelect, $setup.selectedBuilder]
                      ]),
                      _hoisted_14,
                      _createElementVNode("button", {
                        disabled: !$setup.selectedBuilder,
                        onClick: $setup.doSelect
                      }, "Update", 8, _hoisted_15)
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", null, "uid:" + _toDisplayString($setup.auth.user?.uid), 1),
                      _createElementVNode("div", null, "bid:" + _toDisplayString($setup.auth.claims?.['builderId']), 1)
                    ])
                  ], 64))
      ])
    ]),
    _: 1
  }, 8, ["click-to-close"]))
}